"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/chat/v1/portal_service.proto (package spwn.chat.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalChatServiceSaveStreamingAnnouncementResponse = exports.PortalChatServiceSaveStreamingAnnouncementRequest = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from message spwn.chat.v1.PortalChatServiceSaveStreamingAnnouncementRequest
 */
class PortalChatServiceSaveStreamingAnnouncementRequest extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string video_id = 1;
         */
        this.videoId = "";
        /**
         * @generated from field: string message = 2;
         */
        this.message = "";
        /**
         * @generated from field: string event_id = 3;
         */
        this.eventId = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalChatServiceSaveStreamingAnnouncementRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalChatServiceSaveStreamingAnnouncementRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalChatServiceSaveStreamingAnnouncementRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalChatServiceSaveStreamingAnnouncementRequest, a, b);
    }
}
exports.PortalChatServiceSaveStreamingAnnouncementRequest = PortalChatServiceSaveStreamingAnnouncementRequest;
PortalChatServiceSaveStreamingAnnouncementRequest.runtime = protobuf_1.proto3;
PortalChatServiceSaveStreamingAnnouncementRequest.typeName = "spwn.chat.v1.PortalChatServiceSaveStreamingAnnouncementRequest";
PortalChatServiceSaveStreamingAnnouncementRequest.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "video_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.chat.v1.PortalChatServiceSaveStreamingAnnouncementResponse
 */
class PortalChatServiceSaveStreamingAnnouncementResponse extends protobuf_1.Message {
    constructor(data) {
        super();
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PortalChatServiceSaveStreamingAnnouncementResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PortalChatServiceSaveStreamingAnnouncementResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PortalChatServiceSaveStreamingAnnouncementResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(PortalChatServiceSaveStreamingAnnouncementResponse, a, b);
    }
}
exports.PortalChatServiceSaveStreamingAnnouncementResponse = PortalChatServiceSaveStreamingAnnouncementResponse;
PortalChatServiceSaveStreamingAnnouncementResponse.runtime = protobuf_1.proto3;
PortalChatServiceSaveStreamingAnnouncementResponse.typeName = "spwn.chat.v1.PortalChatServiceSaveStreamingAnnouncementResponse";
PortalChatServiceSaveStreamingAnnouncementResponse.fields = protobuf_1.proto3.util.newFieldList(() => []);
//# sourceMappingURL=portal_service_pb.js.map